<template>
  <div>
    <div>
      <div class="info row gy-1 info-edit" v-if="!renderBillingInfo">
        <!-- user name -->
        <div>
          <div class="ps-2 row justify-content-between" >
          <span class=" info-display info-name col-lg-6 col-md-6 col-sm-6 mb-2" v-if="personalInfo.first_name">
                 {{personalInfo?.first_name}} {{personalInfo?.middle_name}} {{personalInfo?.last_name}}
          </span>

          </div>

          <div class="col-12 mb-2" v-if="personalInfo.gender  == 0 || personalInfo.gender == 1">
            <label><strong>Gender: </strong></label>
            <span   v-if="personalInfo.gender == 0"> Male </span>
            <span v-else> Female </span>
          </div>
          <div class="col-12 mb-2" v-if="personalInfo.height_feet">
            <span class="">
              <strong>Height:</strong> {{personalInfo.height_feet}} feet {{personalInfo.height_inch}} Inches
            </span>
          </div>
          <div class="col-12 mb-2" v-if="personalInfo.weight">
            <span class="">
              <strong>Weight:</strong> {{personalInfo.weight}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="personalInfo.birthdate">
            <span class="">
              <strong>Date of Birth:</strong> {{personalInfo.birthdate}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="personalInfo.ssn">
            <span class="">
              <strong>Social security Number:</strong> {{personalInfo.ssn}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="personalInfo.marital_status == 0 || personalInfo.marital_status == 1 || personalInfo.marital_status == 2 || personalInfo.marital_status == 3">
            <label><strong>Marital Status: </strong></label>
            <span v-if="personalInfo.marital_status == 0">
                                Single
                              </span>
            <span  v-if="personalInfo.marital_status == 1">
                                Married
                              </span>
            <span  v-if="personalInfo.marital_status == 2">
                                Divorced
                              </span>
            <span v-if="personalInfo.marital_status == 3">
                                Widowed
                              </span>
          </div>
          <div class="col-12 mb-2" v-if="personalInfo.prior_carrier_name">
            <span class="">
              <strong>Prior Coverage Carrier Name:</strong> {{personalInfo.prior_carrier_name}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="personalInfo.prior_effective_date">
            <span class="">
              <strong>Prior Coverage Effective Date:</strong> {{personalInfo.prior_effective_date}}
            </span>
          </div>
          <div class="col-12 mb-2" v-if="personalInfo.prior_term_date">
            <span class="">
              <strong>Prior Coverage Term Date:</strong> {{personalInfo.prior_term_date}}
            </span>
          </div>
        </div>
        <div class="">
          <button @click="renderBillingInfo = true"
                  class="btn btn-personal-info-edit btn-outline-info info-edit-btn w-100"
          >
            <i class="fas fa-pen me-2"></i>
            Edit Details
          </button>
        </div>
      </div>
      <div v-if="renderBillingInfo">
        <personal-information :isRedirectionFromReview="true"
                              @cancelEditInfo="cancelEditInfo"
                              @updatedEditInfo="updatedEditInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import PersonalInformation from "../PersonalInformation";
export default {
  name: "PersonalInfoEdit",
  props: {
    personalInfo: {
      type: Object
    }
  },
  data () {
    return {
      renderBillingInfo: false
    }
  },
  components: {
    PersonalInformation
  },
  methods: {
    cancelEditInfo () {
      let app = this
      app.renderBillingInfo = false
    },
    updatedEditInfo () {
      let app = this
      app.renderBillingInfo = false
      app.$emit('updatedEditInfo')
    }
  }
}
</script>
<style src="@/assets/css/review_edit.css"></style>
<style scoped>
</style>